import script from "./CompanyLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyLogo.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyLogo.vue?vue&type=style&index=0&id=39328972&scoped=true&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39328972"]])

export default __exports__